// Allgemeine Geschäftsbedingungen. Der Stand muss zu CURRENT_AGB_VERSION im
// Backend (plans.js) passen — Registrierung und Tarifwechsel speichern genau
// diesen Stand als Zustimmung. Wer hier etwas ändert, erhöht dort die Version.
//
// Die Regeln zu Gratismonat, Wechsel und Kündigung spiegeln abo.js wider.
import RechtsRahmen from '../komponenten/RechtsRahmen';

export default function Agb() {
  return (
    <RechtsRahmen titel="Allgemeine Geschäftsbedingungen für LagerPro" stand="1. November 2026">
      <h2>§ 1 Geltungsbereich und Anbieter</h2>
      <p>
        Diese Bedingungen gelten für die Nutzung der Software „LagerPro" (Web-Anwendung unter lagerpro.app,
        Desktop- und Handy-App) der Quantory Solutions GmbH, Hüttenstraße 71, 40215 Düsseldorf
        („Anbieter"). Abweichende Bedingungen des Kunden gelten nicht, auch wenn der Anbieter ihnen nicht
        ausdrücklich widerspricht.
      </p>

      <h2>§ 2 Leistung</h2>
      <p>
        LagerPro ist eine Software zur Verwaltung von Lager, Verkauf, Rechnungen und Buchhaltung, die der
        Anbieter über das Internet bereitstellt (Software as a Service). Der Umfang richtet sich nach dem
        gewählten Tarif (Starter, Professional, Enterprise) gemäß der Leistungsbeschreibung auf
        lagerpro.app zum Zeitpunkt der Buchung. Der Anbieter entwickelt LagerPro weiter; wesentliche
        Funktionen eines gebuchten Tarifs entfallen nicht ohne Ankündigung nach § 12.
      </p>

      <h2>§ 3 Vertragsschluss und Gratismonat</h2>
      <p>
        Der Vertrag kommt mit Abschluss der Registrierung zustande. Die ersten 30 Kalendertage ab
        Registrierung sind im gewählten Tarif kostenlos („Gratismonat"). Wer im Gratismonat kündigt, zahlt
        nichts. Ohne Kündigung läuft der Vertrag danach kostenpflichtig im jeweils gewählten Tarif weiter.
      </p>

      <h2>§ 4 Preise und Zahlung</h2>
      <ul>
        <li>Es gelten die Monatspreise laut Preisübersicht auf lagerpro.app; alle Preise netto zuzüglich gesetzlicher Umsatzsteuer.</li>
        <li>
          Abgerechnet wird je Kalendermonat. Der Monat, in dem der Gratismonat endet, wird anteilig nach
          Tagen berechnet. Individuell vereinbarte Preise (Sonderkonditionen) gehen der Preisübersicht vor.
        </li>
        <li>
          Die Zahlung erfolgt per SEPA-Basislastschrift. Der Kunde erteilt das Mandat spätestens bis zum
          Ende des Gratismonats; ohne Mandat kann der Anbieter den Zugang bis zur Erteilung sperren, die
          Daten bleiben dabei erhalten.
        </li>
        <li>
          Der Anbieter kündigt jede Lastschrift mindestens 5 Kalendertage vor Fälligkeit an
          (verkürzte Frist für die Vorabankündigung).
        </li>
        <li>
          Kosten einer vom Kunden zu vertretenden Rücklastschrift trägt der Kunde. Bei Zahlungsverzug
          kann der Anbieter den Zugang nach Mahnung sperren.
        </li>
      </ul>

      <h2>§ 5 Tarifwechsel</h2>
      <p>
        Der Kunde kann den Tarif jederzeit selbst wechseln. Ein Wechsel in einen höheren Tarif gilt sofort;
        ist der laufende Monat bereits abgerechnet, wird die Preisdifferenz für die restlichen Tage des
        Monats anteilig auf der nächsten Rechnung berechnet. Ein Wechsel in einen niedrigeren Tarif gilt zum
        Ende des laufenden Monats. Im Gratismonat gilt jeder Wechsel sofort und kostenlos. Übersteigt die
        Zahl der Benutzer die Grenze des niedrigeren Tarifs, ist der Wechsel erst nach Entfernen von
        Benutzern möglich. Bei Sonderkonditionen erfolgt ein Wechsel nach Absprache.
      </p>

      <h2>§ 6 Laufzeit und Kündigung</h2>
      <ul>
        <li>Der Vertrag läuft auf unbestimmte Zeit.</li>
        <li>
          Beide Seiten können zum Ende eines Kalendermonats kündigen. Im Gratismonat endet der Vertrag mit
          dem Ende des Gratismonats.
        </li>
        <li>
          Der Kunde kündigt in LagerPro unter „Tarif" oder über die Schaltfläche
          „<a href="/kuendigen">Verträge hier kündigen</a>" auf lagerpro.app, außerdem in Textform
          (z. B. per E-Mail). Der Anbieter bestätigt die Kündigung mit Zeitpunkt des Eingangs und
          Vertragsende per E-Mail.
        </li>
        <li>Eine Kündigung in der App kann bis zum Vertragsende zurückgenommen werden.</li>
        <li>Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.</li>
      </ul>

      <h2>§ 7 Daten nach Vertragsende und Aufbewahrung</h2>
      <p>
        Nach Vertragsende ist LagerPro nicht mehr nutzbar. Der Kunde kann innerhalb von 30 Tagen eine Kopie
        seiner Daten anfordern, wahlweise lesbar (PDF und Tabellen) oder als Wiederherstellungsdatei. Die
        Datei ist mit dem Passwort des Administrator-Zugangs geschützt. Nach Ablauf der 30 Tage löscht der
        Anbieter die Daten des Kunden.
      </p>
      <p>
        Gesetzliche Aufbewahrungspflichten für die Unterlagen des Kunden (z. B. nach § 147 AO und § 257 HGB)
        treffen den Kunden selbst. Der Kunde ist dafür verantwortlich, seine Daten rechtzeitig zu sichern.
      </p>

      <h2>§ 8 Pflichten des Kunden</h2>
      <ul>
        <li>Zugangsdaten geheim halten; Missbrauch unverzüglich melden.</li>
        <li>LagerPro nur im Rahmen der Gesetze nutzen und keine rechtswidrigen Inhalte speichern.</li>
        <li>
          Für die eingegebenen Daten und deren steuerliche und rechtliche Richtigkeit (z. B. Rechnungsangaben)
          ist der Kunde verantwortlich. LagerPro ersetzt keine Steuer- oder Rechtsberatung.
        </li>
        <li>Wichtige Daten regelmäßig zusätzlich selbst sichern (Funktion „Sicherung" bzw. Export).</li>
      </ul>

      <h2>§ 9 Verfügbarkeit</h2>
      <p>
        Der Anbieter bemüht sich um eine möglichst unterbrechungsfreie Verfügbarkeit. Wartungsarbeiten
        werden nach Möglichkeit außerhalb üblicher Geschäftszeiten durchgeführt. Ausfälle durch Umstände
        außerhalb des Einflussbereichs des Anbieters (z. B. Störungen des Internets, höhere Gewalt) sind
        keine Pflichtverletzung.
      </p>

      <h2>§ 10 Haftung</h2>
      <p>
        Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit, bei Verletzung von Leben,
        Körper oder Gesundheit sowie nach dem Produkthaftungsgesetz. Bei leicht fahrlässiger Verletzung
        einer wesentlichen Vertragspflicht ist die Haftung auf den vertragstypisch vorhersehbaren Schaden
        begrenzt; im Übrigen ist die Haftung für leichte Fahrlässigkeit ausgeschlossen. Für den Verlust von
        Daten haftet der Anbieter nur in Höhe des Aufwands, der bei ordnungsgemäßer Datensicherung durch
        den Kunden zur Wiederherstellung erforderlich gewesen wäre.
      </p>

      <h2>§ 11 Datenschutz und Auftragsverarbeitung</h2>
      <p>
        Der Anbieter verarbeitet personenbezogene Daten, die der Kunde in LagerPro speichert, ausschließlich
        in dessen Auftrag und nach dessen Weisung (Art. 28 DSGVO). Einzelheiten regelt der Vertrag zur
        Auftragsverarbeitung, den der Anbieter auf Anforderung bereitstellt. Im Übrigen gilt die
        <a href="/datenschutz"> Datenschutzerklärung</a>.
      </p>

      <h2>§ 12 Änderungen dieser Bedingungen</h2>
      <p>
        Der Anbieter kann diese Bedingungen mit Wirkung für die Zukunft ändern, wenn dafür ein sachlicher
        Grund besteht (z. B. Gesetzesänderung, neue Funktionen). Er teilt Änderungen mindestens sechs Wochen
        vor Inkrafttreten per E-Mail mit. Widerspricht der Kunde nicht bis zum Inkrafttreten, gelten die
        Änderungen als angenommen; auf diese Folge weist der Anbieter in der Mitteilung hin. Widerspricht
        der Kunde, kann jede Seite zum Inkrafttreten kündigen.
      </p>

      <h2>§ 13 Widerrufsrecht für Verbraucher</h2>
      <p>Ist der Kunde Verbraucher (§ 13 BGB), steht ihm folgendes Widerrufsrecht zu:</p>
      <h3>Widerrufsbelehrung</h3>
      <p>
        Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die
        Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses. Um Ihr Widerrufsrecht
        auszuüben, müssen Sie uns (Quantory Solutions GmbH, Hüttenstraße 71, 40215 Düsseldorf,
        E-Mail: info@quantory.de, Telefon: 01777 317755) mittels einer eindeutigen Erklärung (z. B. ein mit
        der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen,
        informieren. Sie können dafür das unten stehende Muster-Widerrufsformular verwenden, das jedoch
        nicht vorgeschrieben ist. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über
        die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
      </p>
      <h3>Folgen des Widerrufs</h3>
      <p>
        Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben,
        unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung
        über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir
        dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn,
        mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser
        Rückzahlung Entgelte berechnet. Haben Sie verlangt, dass die Dienstleistungen während der
        Widerrufsfrist beginnen sollen, so haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil
        der bis zum Widerruf bereits erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im
        Vertrag vorgesehenen Dienstleistungen entspricht. Da die ersten 30 Tage kostenlos sind, fällt
        innerhalb der Widerrufsfrist kein Entgelt an.
      </p>
      <h3>Muster-Widerrufsformular</h3>
      <p>
        (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es
        zurück.)<br />
        An Quantory Solutions GmbH, Hüttenstraße 71, 40215 Düsseldorf, info@quantory.de:<br />
        Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über die Erbringung der
        folgenden Dienstleistung: LagerPro<br />
        Bestellt am (*)/erhalten am (*) · Name des/der Verbraucher(s) · Anschrift des/der Verbraucher(s) ·
        Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier) · Datum<br />
        (*) Unzutreffendes streichen.
      </p>

      <h2>§ 14 Schlussbestimmungen</h2>
      <p>
        Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts; bei Verbrauchern
        nur, soweit dadurch nicht zwingender Schutz des Staates entzogen wird, in dem sie ihren gewöhnlichen
        Aufenthalt haben. Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder
        öffentlich-rechtliches Sondervermögen, ist Gerichtsstand Düsseldorf. Sollte eine Bestimmung
        unwirksam sein, bleibt der Vertrag im Übrigen wirksam.
      </p>
    </RechtsRahmen>
  );
}
